<div class="loading" *ngIf="showLoading$ | async">
  <img class="loading__img" src="assets/img/simbolo-renault.png" alt="Loading de Renault" />
</div>
